"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs
 * API documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfAdminUsersResponseDto = instanceOfAdminUsersResponseDto;
exports.AdminUsersResponseDtoFromJSON = AdminUsersResponseDtoFromJSON;
exports.AdminUsersResponseDtoFromJSONTyped = AdminUsersResponseDtoFromJSONTyped;
exports.AdminUsersResponseDtoToJSON = AdminUsersResponseDtoToJSON;
exports.AdminUsersResponseDtoToJSONTyped = AdminUsersResponseDtoToJSONTyped;
var PaginationDetailsDto_1 = require("./PaginationDetailsDto");
var AdminUserDto_1 = require("./AdminUserDto");
/**
 * Check if a given object implements the AdminUsersResponseDto interface.
 */
function instanceOfAdminUsersResponseDto(value) {
    if (!('users' in value) || value['users'] === undefined)
        return false;
    return true;
}
function AdminUsersResponseDtoFromJSON(json) {
    return AdminUsersResponseDtoFromJSONTyped(json, false);
}
function AdminUsersResponseDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'users': (json['users'].map(AdminUserDto_1.AdminUserDtoFromJSON)),
        'pagination': json['pagination'] == null ? undefined : (0, PaginationDetailsDto_1.PaginationDetailsDtoFromJSON)(json['pagination']),
    };
}
function AdminUsersResponseDtoToJSON(json) {
    return AdminUsersResponseDtoToJSONTyped(json, false);
}
function AdminUsersResponseDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'users': (value['users'].map(AdminUserDto_1.AdminUserDtoToJSON)),
        'pagination': (0, PaginationDetailsDto_1.PaginationDetailsDtoToJSON)(value['pagination']),
    };
}
